import { CloseIcon } from '@blocksuite/icons/rc';
import { useLiveData } from '@toeverything/infra';
import { type ReactElement } from 'react';

import { CitationContent } from './citation-content';
import { activeCitation$, closeCitationPanel } from './state';
import * as styles from './styles.css';

/**
 * Docked side panel that shows the active citation's source (PDF or web view)
 * beside the current doc. Mounted in the workbench layout next to the main
 * content so the doc stays visible on the left — no context switch, and not a
 * modal. Renders nothing when no citation is active.
 */
export const CitationSidePanel = (): ReactElement | null => {
  const citation = useLiveData(activeCitation$);
  if (!citation) return null;

  const title = citation.title?.trim() || citation.identifier || 'Citation';

  return (
    <div className={styles.panel} data-testid="citation-side-panel">
      <div className={styles.header}>
        <span className={styles.title} title={title}>
          {title}
        </span>
        <button
          className={styles.closeButton}
          onClick={() => closeCitationPanel()}
          aria-label="Close citation"
        >
          <CloseIcon />
        </button>
      </div>
      <CitationContent citation={citation} />
    </div>
  );
};
